import React from "react";
import Link from "next/link";
import Image from "next/image";
import { ArticleShort } from "lib/types/article";
import { buildArticleBreadcrumbs } from "lib/utils/articleBreadcrumbs";
import { imageLoader } from "utils";
import { TRANSPARENT_PIXEL } from "lib/constants/shared";
import ArticleHeadline from "components/article/ArticleHeadline";

interface MainArticleProps {
  article: ArticleShort;
}

const MainArticle = ({ article }: MainArticleProps) => {
  const breadcrumbItems = buildArticleBreadcrumbs(article, {
    sectorIsLink: true,
    categoryIsLink: false,
  });

  return (
    <article className="group flex w-full flex-col items-center gap-4 text-center">
      <div className="flex w-full flex-col items-center gap-2">
        {breadcrumbItems.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-1">
            {breadcrumbItems}
          </div>
        )}

        <Link
          href={article.url}
          aria-label={article.title}
          className="flex w-full flex-col items-center gap-4"
        >
          <div>
            <ArticleHeadline
              title={article.title}
              isProContent={article.isProContent}
              size="large"
              as="h1"
              className="text-center"
            />

            {article.excerpt && (
              <p className="mt-2 text-center text-regular-16 leading-[1.3] text-black-rock">
                {article.excerpt}
              </p>
            )}
          </div>

          {article.image?.base && (
            <div className="relative aspect-[4/3] w-full overflow-hidden bg-gray-200">
              <Image
                loader={imageLoader}
                src={article.image.base}
                alt={article.image?.alt?.toString() || article.title}
                width={400}
                height={300}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                className="h-full w-full object-cover transition-opacity group-hover:opacity-90"
                blurDataURL={article.image?.placeholder || TRANSPARENT_PIXEL}
                placeholder="blur"
                priority
              />
            </div>
          )}
        </Link>
      </div>
    </article>
  );
};

export default MainArticle;
